module.exports = {
    setup: function(checkoutForm) {
        window.billing_cb = checkoutForm.querySelector('#billing_same');
        window.billing_cb.checked = 1;
        checkoutForm.querySelectorAll('fieldset.billing').forEach(function (el) {
            el.style.display = 'none';
        });
        window.billing_cb.onchange = function() {
            var billingFields = checkoutForm.querySelectorAll('fieldset.billing').forEach(function (el) {
                el.style.display = window.billing_cb.checked ? 'none' : 'block';
            });
        }
    },
}